import React, { useRef } from "react";
import styled from "styled-components";
import { VirtuosoGrid } from "react-virtuoso";
import ResizeObserver from "resize-observer-polyfill";
import "./style.scss";
import StashItem from "../Stash/stash-item";
import { Spinner } from "react-bootstrap";

if (!window.ResizeObserver) {
    window.ResizeObserver = ResizeObserver
}

const ItemContainer = styled.div`
//   padding: 0.5rem;
  width: 33%;
  display: flex;
  flex: none;
  align-content: stretch;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    // width: 50%;
  }

  @media (max-width: 300px) {
    width: 100%;
  }
`

const ItemWrapper = styled.div`
  flex: 1;
  text-align: center;
//   font-size: 80%;
//   padding: 1rem 1rem;
//   border: 1px solid var(gray);
  white-space: nowrap;
`

const ListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const Footer = () => {
  return (
    <div className="preloading-container" style={{ height: '5vh' }}>
      <Spinner size="lg" animation="border" variant="primary" />
    </div>
  );
}

export default function VirtualizedGridList({ items, maxSelection, source, changePage, hasMore }) {
  const virtuoso = useRef(null);

  const getMoreMedia = () => {
    changePage();
  }

  return (
    <VirtuosoGrid
      ref={virtuoso}
      data={items}
      components={{
        Item: ItemContainer,
        List: ListContainer,
        Footer: hasMore ? Footer : null
      }}
      style={{ width: '100%' }}
      itemContent={
        index => <ItemWrapper>
          <StashItem
            key={items[index].media_id}
            item={items[index]}
            max={maxSelection}
            source={source}
          />
        </ItemWrapper>
      }
      overscan={30}
      endReached={getMoreMedia}
    />
  );
}

